// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"691":"8f7be8e9","832":"bda835c5"}[chunkId] + ".chunk.css";
};